import Aircrafts from '@/models/Aircrafts';

let pilotID = 1;

export default class Pilot {
  constructor({
    id = 1,
    name = '',
    rank,
    pilotSkill,
    other,
    aircraft = null,
  }) {
    if (id == null) {
      this.id = pilotID;
      pilotID += 1;
    } else {
      this.id = id;
    }
    this.name = name;
    this.aircraft = aircraft;
    this.rank = rank;
    this.other = other;
    this.pilotSkill = pilotSkill;
  }

  get ammoSlots() {
    if (this.aircraft == null || this.aircraft.ammoLimitAsNumber == null) {
      return null;
    }
    return Array.from(Array(this.aircraft.ammoLimitAsNumber)
      .fill(0)
      .keys());
  }

  get ammoSlotRows() {
    if (this.ammoSlots == null) {
      return null;
    }
    const rows = [];
    for (let i = 0; i < Math.ceil(this.ammoSlots.length / 10); i += 1) {
      rows.push({
        i,
        ammoSlots: this.ammoSlots.slice(10 * i, 10 * (i + 1)),
      });
    }
    return rows;
  }

  toJSON() {
    return {
      id: this.id,
      name: this.name,
      rank: this.rank,
      pilotSkill: this.pilotSkill,
      other: this.other,
      aircraftType: this.aircraft != null ? this.aircraft.type : null,
    };
  }

  static fromJSON(json) {
    return new Pilot({
      id: json.id,
      name: json.name,
      rank: json.rank,
      pilotSkill: json.pilotSkill,
      other: json.other,
      aircraft: json.aircraftType != null
        ? Aircrafts.find((x) => x.type === json.aircraftType)
        : null,
    });
  }
}
